import { useRx } from './use-rx.hook';
import { Navigator } from '../services';

export function useNavigatorState<T>(defaultValue: T): T {
  if (!Navigator._state.getValue()) {
    Navigator._state.next(defaultValue);
  }
  return useRx(Navigator._state) as T;
}
